import styled from "@emotion/styled";
import FormContainer from "global/containers/form";

export const Form = styled(FormContainer.Form)`
  --form-row-gap: 24px;
`;
